import { render } from "./TokColor.vue?vue&type=template&id=05f98700&scoped=true"
import script from "./TokColor.vue?vue&type=script&lang=js"
export * from "./TokColor.vue?vue&type=script&lang=js"

import "./TokColor.vue?vue&type=style&index=0&id=05f98700&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f98700"]])

export default __exports__